import { optimizelyClientInstance, optimizelyUserId } from './optimizely-loader';

const QP_FORCE_OPTIMIZELY_FEATURE = 'force_optimizely_feature';
const QP_FORCE_OPTIMIZELY_EXPERIMENT = 'force_optimizely_experiment';
const ATTR_FEATURE_CONTROL = 'data-optimizely-feature-control';
const ATTR_FEATURE_VARIATION = 'data-optimizely-feature-variation';

const getQueryParamBoolean = (params, qpName) => {
  if (!params.has(qpName)) {
    return null;
  }

  const qpValue = params.get(qpName);
  return !!['1', 'true'].find((val) => val === qpValue);
}

const getQueryParamEnum = (params, qpName, values) => {
  if (!params.has(qpName)) {
    return null;
  }

  const qpValue = params.get(qpName);
  const selectedValue =  values.find(val => val === qpValue);
  return selectedValue || null;
}

const readParams = () => {
  const normalQueryParams = new URLSearchParams(location.search);

  //Check for oauth;
  try {
    const hashAsParams = new URLSearchParams(decodeURIComponent(location.hash.substring(1)));
    if (!hashAsParams.has('state')) {
      return normalQueryParams;
    }

    const stateObj = JSON.parse(hashAsParams.get('state'));
    return new URLSearchParams(stateObj.parent_query_params || null);
  } catch(e) {
    return normalQueryParams;
  }
}

const readOptimizelyConfig = () => {
  const htmlConfig = document.getElementById('optimizely-conf');
  if (!htmlConfig) {
    console.error('No Optimizely configuration detected');
    return {};
  }

  let config = {
    featureKey: htmlConfig.getAttribute('data-config-optimizely-feature-key'),
    featureEnabled: false,
    experimentKey: htmlConfig.getAttribute('data-config-optimizely-experiment-key'),
    experimentSelectedVariation: htmlConfig.getAttribute('data-config-optimizely-experiment-default-variation'),
    experimentVariations: [htmlConfig.getAttribute('data-config-optimizely-experiment-default-variation')],
    elementsBehaviour: htmlConfig.getAttribute('data-config-optimizely-elements-behaviour'),
  };
  const params = readParams();

  if (config.featureKey) {
    const featureForcedStatus = getQueryParamBoolean(params, QP_FORCE_OPTIMIZELY_FEATURE);
    config.featureEnabled = featureForcedStatus === null
      ? optimizelyClientInstance.isFeatureEnabled(config.featureKey, optimizelyUserId)
      : featureForcedStatus;
  }

  if (config.experimentKey) {
    const commaVariations = htmlConfig.getAttribute('data-config-optimizely-experiment-variations');
    if (commaVariations) {
      config.experimentVariations = commaVariations.split(',');
      const experimentForced = getQueryParamEnum(params, QP_FORCE_OPTIMIZELY_EXPERIMENT, config.experimentVariations);
      config.experimentSelectedVariation = experimentForced
        || optimizelyClientInstance.activate(config.experimentKey, optimizelyUserId)
        || config.experimentSelectedVariation;
    }
  }

  return config;
};

const deleteAllAttributeElements = (attrName, config) => {
  Array.from(document.querySelectorAll(`[${attrName}]`)).forEach(element => {
    switch (config.elementsBehaviour) {
      case 'destroy':
        element.parentElement.removeChild(element);
        return;
      case 'hide':
      default:
        element.style.display = 'none';
        return;
    }
  });
}

const optimizelyHandleFeature = (config) => {
  if (!config || !config.featureKey) {
    console.error('No feature configuration provided');
    return;
  }

  try {
    if (config.featureEnabled) {
      require('./fever-widget');
      deleteAllAttributeElements(ATTR_FEATURE_CONTROL, config);
    } else {
      const widget = document.getElementById('widget');
      widget.setAttribute('data-widget-hidden', 'true');
      require('./fever-widget');
      deleteAllAttributeElements(ATTR_FEATURE_VARIATION, config);
    }
  } catch(e) {
    console.error('Error loading the ABtest widget:', e.message);
    deleteAllAttributeElements(ATTR_FEATURE_VARIATION, config);
  }
};

const optimizelyHandleExperiment = (config) => {
  if (!config || !config.experimentKey) {
    console.error('No experiment configuration provided');
    return;
  }

  config.experimentVariations.forEach((variation) => {
    if (variation !== config.experimentSelectedVariation) {
      deleteAllAttributeElements(`data-optimizely-${variation}`, config);
    }
  });
};

optimizelyClientInstance.onReady().then(() => {
  const config = readOptimizelyConfig();

  // If you want to handle better the feature change the function optimizelyHandleFeature
  if (config.featureKey) {
    optimizelyHandleFeature(config);
  }

  // If you want to handle better the experiment change the function optimizelyHandleExperiment
  if (config.experimentKey) {
    optimizelyHandleExperiment(config);
  }
});
